import i18n from 'services/base/i18n';

export default {
  seen:    () => i18n.pgettext('Enums|Seen', 'Seen'),
  new:     () => i18n.pgettext('Enums|Seen', 'New'),
  unknown: () => i18n.pgettext('Enums|Seen', 'Unknown'),
};
